<template>
  <div class="quantity">
    <div class="number-spinner">
      <span class="min" v-on:click="spinnerDown">-</span>
      <input type="text" v-bind:name="name" v-bind:value="intern_value" v-on:input="change" v-bind:max="max" v-bind:min="min" class="spinner" />
      <span class="plus" v-on:click="spinnerUp">+</span>
    </div>
  </div>
</template>

<script>


  /**
   * spinner component, responsible for displaying the - + input spinner
   */

  export default {

    props: {

      'min': {

        'type': Number,
        'default': 0
      },

      'max': {
        'type': Number,
        'default': 50
      },

      'value': { type: Number }, 'name': { type: String }

      },

    data: function () {
      return { intern_value: this.value };
    },
    watch: {
      value: function (val) {
        this.intern_value = val;
      }
    },
    methods: {
      spinnerUp: function (event) {
        if (this.value < this.max) {
          this.intern_value++;
          this.$nextTick(function () {
            this.$emit('input', this.intern_value);
            this.$emit('quantitychange', { oldValue: this.intern_value - 1, newValue: this.intern_value });
            //console.log(this.$el.textContent) // => 'updated'
          });
        }
        //console.log("spinner up  changed");
      },
      spinnerDown: function (event) {
        if (this.value > this.min) {
          this.intern_value--;
          this.$nextTick(function () {
            this.$emit('input', this.intern_value);
            this.$emit('quantitychange', { oldValue: this.intern_value + 1, newValue: this.intern_value });
          });
        }
      },
      change: function (event) {

        var oldValue = this.intern_value;
        var newvalue = parseInt(event.target.value);

        if (isNaN(newvalue)) {
          newvalue = 0;
        }

        if (newvalue < this.min) {
          newvalue = this.min;
        }
        if (newvalue > this.max) {
          newvalue = this.max;
        }
        if (oldValue != newvalue) {
          this.intern_value = newvalue;
          this.$emit('input', this.intern_value);
          this.$emit('quantitychange', { oldValue: oldValue, newValue: this.intern_value });
        }
        
      }
    }
  }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-spinner.vue